import React from 'react';
import moment from "moment";
import neoLogo from "../../../../assets/images/Neo_Logo_A.svg";

/**
 * PrintableExtraEventReport
 * Componente oculto na tela que renderiza o relatório de conquistas
 * de eventos extras, otimizado para impressão A4.
 */
class PrintableExtraEventReport extends React.Component {
    render() {
        const { awards, event, tenantName, tenantLogo } = this.props;

        if (!awards || awards.length === 0) return null;

        const dateStart = event?.startDate
            ? moment(event.startDate).format("DD/MM/YYYY")
            : "--";
        const dateEnd = event?.endDate
            ? moment(event.endDate).format("DD/MM/YYYY")
            : "--";

        return (
            <div style={{ padding: "30px 40px", fontFamily: "'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif", color: "#333", backgroundColor: "#fff" }}>

                {/* ═══ CABEÇALHO ═══ */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "2px solid #eee", paddingBottom: "20px", marginBottom: "24px" }}>
                    {/* ESQUERDA: Logo */}
                    <div style={{ flex: "0 0 auto", minWidth: "120px" }}>
                        {tenantLogo && (
                            <img src={tenantLogo} alt="Logo" style={{ maxHeight: "70px", maxWidth: "160px", objectFit: "contain" }} />
                        )}
                    </div>

                    {/* DIREITA: Nome + Dados do Evento */}
                    <div style={{ textAlign: "right", flex: "1 1 auto", paddingLeft: "15px" }}>
                        <h2 style={{ margin: "0 0 6px 0", fontSize: "14px", fontWeight: "700", color: "#555", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                            {tenantName || "Empresa"}
                        </h2>
                        <h3 style={{ margin: "0 0 4px 0", fontSize: "18px", fontWeight: "700", color: "#111" }}>
                            {event?.name || "Resultados Oficiais"}
                        </h3>

                        <p style={{ margin: "2px 0", fontSize: "13px", color: "#555" }}>
                            <strong>Período:</strong> {dateStart} a {dateEnd}
                        </p>
                    </div>
                </div>

                {/* ═══ TABELA DE RESULTADOS ═══ */}
                <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: "24px", fontSize: "13px" }}>
                    <thead>
                        <tr style={{ backgroundColor: "#212529", color: "#fff", textAlign: "left" }}>
                            <th style={{ padding: "10px 12px", fontWeight: "600", width: "5%", textAlign: "center" }}>#</th>
                            <th style={{ padding: "10px 12px", fontWeight: "600", width: "40%" }}>Atleta / Aluno</th>
                            <th style={{ padding: "10px 12px", fontWeight: "600", width: "20%" }}>Entregue Em</th>
                            <th style={{ padding: "10px 12px", fontWeight: "600", textAlign: "center", width: "15%" }}>XP Ganha</th>
                            <th style={{ padding: "10px 12px", fontWeight: "600", width: "20%" }}>Entregue Por</th>
                        </tr>
                    </thead>
                    <tbody>
                        {awards.map((ev, index) => {
                            const dateStr = ev.awardedAt ? moment(ev.awardedAt).format("DD/MM/YYYY") : "-";
                            return (
                                <tr
                                    key={ev.id || index}
                                    style={{
                                        borderBottom: "1px solid #dee2e6",
                                        backgroundColor: index % 2 === 0 ? "#fff" : "#f8f9fa"
                                    }}
                                >
                                    <td style={{ padding: "9px 12px", textAlign: "center", fontWeight: "600", color: "#888" }}>
                                        {index + 1}
                                    </td>
                                    <td style={{ padding: "9px 12px", fontWeight: "600", color: "#111", textTransform: "uppercase", fontSize: "12px" }}>
                                        {ev.memberName || "Desconhecido"}
                                    </td>
                                    <td style={{ padding: "9px 12px", color: "#555", fontSize: "12px" }}>
                                        {dateStr}
                                    </td>
                                    <td style={{ padding: "9px 12px", textAlign: "center", fontWeight: "700", color: "#2ecc71" }}>
                                        {ev.rewardXp ? `+${ev.rewardXp} XP` : "-"}
                                    </td>
                                    <td style={{ padding: "9px 12px", color: "#777", textTransform: "uppercase", fontSize: "11px" }}>
                                        {ev.employeeName || "Sistema"}
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>

                {/* ═══ RESUMO ═══ */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "40px", marginBottom: "40px" }}>
                    <div style={{ flex: 1 }}>
                        <div style={{ backgroundColor: "#f8f9fa", padding: "16px 20px", borderRadius: "8px", border: "1px solid #e9ecef" }}>
                            <div style={{ display: "flex", justifyContent: "space-between", fontSize: "14px" }}>
                                <span style={{ color: "#666" }}>Total de Premiações:</span>
                                <span style={{ fontWeight: "600", color: "#333" }}>{awards.length}</span>
                            </div>
                        </div>
                    </div>
                    {/* Espaço para Assinatura do Organizador */}
                    <div style={{ width: "280px", paddingTop: "40px", textAlign: "center" }}>
                        <div style={{ borderTop: "1px solid #333", paddingTop: "8px" }}>
                            <p style={{ margin: 0, fontSize: "12px", color: "#555", fontWeight: "600" }}>Responsável / Organizador</p>
                        </div>
                    </div>
                </div>

                {/* ═══ RODAPÉ ═══ */}
                <div style={{ marginTop: "40px", paddingTop: "20px", borderTop: "2px solid #eee" }}>
                    <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "flex-end" }}>
                        <div style={{ textAlign: "right" }}>
                            <p style={{ margin: "0 0 5px 0", fontSize: "11px", fontStyle: "italic", color: "#999" }}>
                                Gerado em {moment().format("DD/MM/YYYY [às] HH:mm")}.
                            </p>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "6px", marginTop: "8px" }}>
                                <span style={{ fontSize: "11px", fontWeight: "700", color: "#aaa", letterSpacing: "1px" }}>POWERED BY</span>
                                <img src={neoLogo} alt="NeoApp" style={{ height: "14px", filter: "grayscale(100%) opacity(0.6)" }} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PrintableExtraEventReport;
